import { render, staticRenderFns } from "./HorseCard.vue?vue&type=template&id=cc02741e&"
import script from "./HorseCard.vue?vue&type=script&lang=js&"
export * from "./HorseCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports